import styled from 'styled-components';

import { Button } from 'features/common/components/Button';

export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	min-height: 100vh;
	background: transparent;
	padding: 6rem 0 2rem 0;
	overflow-y: auto;
	z-index: 1;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 1200px;
	padding: 2rem;
	background: transparent;
	border-radius: 12px;
	margin: 0 2rem 2rem 2rem;
	z-index: 1;
`;

export const Title = styled.h1`
	font-size: 2.5rem;
	font-weight: 700;
	color: white;
	margin-bottom: 1rem;
	text-align: center;
`;

export const BodyText = styled.p`
	font-size: 1.1rem;
	color: #e5e7eb;
	text-align: center;
	margin-bottom: 2rem;
	max-width: 600px;
	line-height: 1.6;
`;

export const DownloadButton = styled(Button)`
	font-size: 16px;
	font-weight: 500;
	margin: 0;
	padding: 14px;
`;

// New styled components for events
export const LoadingText = styled.div`
	font-size: 1.1rem;
	color: #e5e7eb;
	text-align: center;
	padding: 2rem;
`;

export const EventsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	gap: 1.5rem;
	width: 100%;
	margin-bottom: 2rem;
`;

export const EventCard = styled.div`
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 12px;
	overflow: hidden;
	cursor: pointer;
	transition: all 0.2s ease;
	backdrop-filter: blur(10px);

	&:hover {
		transform: translateY(-2px);
		border-color: rgba(255, 255, 255, 0.3);
		background: rgba(255, 255, 255, 0.1);
	}
`;

export const EventImage = styled.img`
	width: 100%;
	height: 200px;
	object-fit: cover;
`;

export const EventContent = styled.div`
	padding: 1.5rem;
`;

export const EventTitle = styled.h3`
	font-size: 1.25rem;
	font-weight: 600;
	color: white;
	margin: 0 0 1rem 0;
	line-height: 1.4;
`;

export const EventDetails = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	margin-bottom: 1rem;
`;

export const DetailItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	color: #6b7280;
	font-size: 0.9rem;
`;

export const DetailText = styled.span`
	color: #e5e7eb;
	font-weight: 500;
`;

export const EventDescription = styled.p`
	color: #d1d5db;
	font-size: 0.9rem;
	line-height: 1.5;
	margin: 0;
`;

export const NoEventsText = styled.div`
	font-size: 1.1rem;
	color: #e5e7eb;
	text-align: center;
	padding: 2rem;
`;

export const Divider = styled.hr`
	width: 100%;
	border: none;
	border-top: 1px solid #e5e7eb;
	margin: 2rem 0;
`;

export const MobileSection = styled.div`
	text-align: center;
	width: 100%;
`;

export const MobileTitle = styled.h2`
	font-size: 1.5rem;
	font-weight: 600;
	color: white;
	margin-bottom: 0.5rem;
`;

export const MobileText = styled.p`
	font-size: 1rem;
	color: #e5e7eb;
	margin-bottom: 1.5rem;
`;

export const ButtonGroup = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
	flex-wrap: wrap;
`;
